import { Link, useParams } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import useSeo from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import ArticleView from "@/pages/article/components/ArticleView";

function ArticleMissing() {
  useSeo({
    title: "内容不存在 - 17爆料网",
    description: "该内容可能已调整或下线，请返回热点聚合页浏览其他事件整理。",
    path: "/topics",
  });

  return (
    <main className="flex w-full flex-1 flex-col items-center justify-center px-4 py-24 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-file-unknow-line text-3xl"></i>
      </span>
      <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950">没有找到这篇内容</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        这篇整理可能已经调整或下线。你可以回到热点聚合页继续浏览其他事件。
      </p>
      <Link
        to="/topics"
        className="mt-6 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
      >
        返回热点聚合
      </Link>
    </main>
  );
}

export default function ArticleDetail() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      {article ? (
        <main className="w-full flex-1">
          <ArticleView article={article} />
        </main>
      ) : (
        <ArticleMissing />
      )}
      {article && <BackToTop />}
      <SiteFooter />
    </div>
  );
}